const env = process.env.NODE_ENV || 'development'

export const reportError = (error) => {
  if (env === 'production') {
    if (window.Sentry) {
      window.Sentry.captureException(error)
    }
  } else {
    console.error(error)
  }
}
